(() => {
  angular
    .module('gm.common.directives')
    .directive('gmNoValidation', gmNoValidationDirective);

  function gmNoValidationDirective() {
    'ngInject';

    return {
      require: 'ngModel',
      restrict: 'A',
      link: (_scope, _element, attrs, ctrl) => {
        const validator = attrs.gmNoValidation || 'email';

        ctrl.$validators[validator] = () => true;
      },
    };
  }
})();
